import { render } from "./ConfirmationModal.vue?vue&type=template&id=6a2e05c0&scoped=true"
import script from "./ConfirmationModal.vue?vue&type=script&lang=js"
export * from "./ConfirmationModal.vue?vue&type=script&lang=js"

import "./ConfirmationModal.vue?vue&type=style&index=0&id=6a2e05c0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6a2e05c0"

export default script